module.exports = __webpack_public_path__ + "images/emoji/girl.391850a798451382ed08.png";